import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		clave: '',
		proyecto: '0'
	}
});


// WEBPACK FOOTER //
// ./src/store/index.js